import React from 'react';

class Passion extends React.Component {

    render() {
        return (
            <div className="life-experience">
                <iframe title={this.props.data.title} src={this.props.data.link} allowFullScreen></iframe>

                <h3>{this.props.data.title} | {this.props.data.organization}</h3>
                <p>{this.props.data.timeframe}</p>
                <p>{this.props.data.description}</p>
            </div>
        )
    }

}

export default Passion